import { render, staticRenderFns } from "./PackagingSorting.vue?vue&type=template&id=1e681539&scoped=true&"
import script from "./PackagingSorting.vue?vue&type=script&lang=js&"
export * from "./PackagingSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e681539",
  null
  
)

export default component.exports